var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:[' bg-secondary-DEFAULT animate-pulse rounded-lg', _vm.height, _vm.width]},'div',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }